export default {"src":"/_next/static/media/logo.304c6fe1.svg","height":32,"width":46,"blurWidth":0,"blurHeight":0};